import React from 'react';
import FormTextField from '../../../../components/form/text-field';
import SSMFieldWrapper from '../ssm-field-wrapper/ssm-field-wrapper';

const ContactDetails = (props) => {
  const {
    sectionHeadingText,
    formFields,
    formFieldsIds,
    formFieldsState,
    handleOnBlur,
    handleOnChange,
    selectedSiteContactFormErrors,
  } = props;

  const fieldWrapperConfiguration = {
    authorableContent: formFields,
    state: formFieldsState,
    onBlurFunction: handleOnBlur,
    onChangeFunction: handleOnChange,
    hasErrors: selectedSiteContactFormErrors,
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12 section-heading pl-sm-0">
          <h2>{sectionHeadingText}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.firstName}
            customClass="block-spacer"
          />
        </div>
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.lastName}
            customClass="block-spacer"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.phone}
            customClass="block-spacer"
          />
        </div>
        <div className="col-md-6 pl-sm-0">
          <SSMFieldWrapper
            config={fieldWrapperConfiguration}
            EditField={FormTextField}
            id={formFieldsIds.email}
            customClass="block-spacer"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContactDetails;
